// extracted by mini-css-extract-plugin
export default {"products_container":"Results_products_container__Y1Aah"};